import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const NavigationButtons = ({
  currentStep,
  totalSteps,
  onPrevious,
  onNext,
  isNextDisabled
}) => {
  return (
    <div className="mt-8 flex justify-between gap-3 border-t border-m-border-light pt-6">
      <button
        type="button"
        onClick={onPrevious}
        disabled={currentStep === 1}
        className="auth-btn-outline gap-1.5 disabled:opacity-50"
      >
        <ChevronLeft className="h-4 w-4" />
        Previous
      </button>
      {currentStep < totalSteps && currentStep !== 4 && (
        <button
          type="button"
          onClick={onNext}
          disabled={isNextDisabled}
          className="marketing-btn marketing-btn-ink gap-1.5"
        >
          Next step
          <ChevronRight className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};

export default NavigationButtons;
